// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mat-mdc-form-field ~ .mat-mdc-form-field {
  margin-left: 0;
}

.login-form {
  display: flex;
  flex-direction: column;
  max-width: 350px;
}

.login-field {
  width: 100%;
}

.forget-password {
  margin-top: 8px;
}

.buttons {
  margin-top: 8px;
}

.test-user-list {
  font-size: 12px;
}

.shift-right {
  right: 1.15rem;
}

h1 {
  font: 400 34px/32px Roboto, Helvetica Neue, sans-serif;
  letter-spacing: normal;
  margin-bottom: 64px;
  margin-top: 0;
}

::ng-deep .mdc-text-field {
  background-color: transparent !important;
}`, "",{"version":3,"sources":["webpack://./src/app/auth/login/login-form/login-form.component.scss","webpack://./src/styles/abstracts/_variables.scss"],"names":[],"mappings":"AAEA;EACE,cAAA;AADF;;AAIA;EACE,aAAA;EACA,sBAAA;EACA,gBAAA;AADF;;AAIA;EACE,WAAA;AADF;;AAIA;EACE,eCPS;ADMX;;AAIA;EACE,eCXS;ADUX;;AAIA;EACE,eAAA;AADF;;AAIA;EACE,cAAA;AADF;;AAIA;EACE,sDAAA;EACA,sBAAA;EACA,mBAAA;EACA,aAAA;AADF;;AAIA;EACE,wCAAA;AADF","sourcesContent":["@use './src/styles/abstracts/variables' as var;\r\n\r\n.mat-mdc-form-field~.mat-mdc-form-field {\r\n  margin-left: 0;\r\n}\r\n\r\n.login-form {\r\n  display: flex;\r\n  flex-direction: column;\r\n  max-width: 350px;\r\n}\r\n\r\n.login-field {\r\n  width: 100%;\r\n}\r\n\r\n.forget-password {\r\n  margin-top: var.$space-sm;\r\n}\r\n\r\n.buttons {\r\n  margin-top: var.$space-sm;\r\n}\r\n\r\n.test-user-list {\r\n  font-size: 12px;\r\n}\r\n\r\n.shift-right {\r\n  right: 1.15rem;\r\n}\r\n\r\nh1 {\r\n  font: 400 34px / 32px Roboto, Helvetica Neue, sans-serif;\r\n  letter-spacing: normal;\r\n  margin-bottom: 64px;\r\n  margin-top: 0;\r\n}\r\n\r\n::ng-deep .mdc-text-field {\r\n  background-color: transparent !important;\r\n}","// Brand Colors\r\n$brand-blue-light: #a8c0e4;\r\n$brand-maroon: #a12041;\r\n$brand-maroon-swap: #1a8435;\r\n$brand-gray-darker: #58595b;\r\n$brand-gray-dark: #808285;\r\n$brand-gray-light: #a7a9ac;\r\n$brand-gray-lightest: #d1d3d4;\r\n\r\n// Spacing\r\n$space-sm: 8px;\r\n$space-md: 16px;\r\n$space-lg: 24px;\r\n\r\n// Side Nav\r\n$side-nav-width: 210px;\r\n$side-nav-color: #f6f6f6;\r\n$side-nav-color-hover: rgba(0, 0, 0, 0.04);\r\n\r\n// Media Res\r\n$tablet: 768px;"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
